import * as React from 'react';

import AvatarWithText from 'components/AvatarWithText';
import BoxBody from 'components/BoxBody';
import Button from 'components/Button';
import Dialog from 'components/Dialog';
import FormElement from 'components/FormElement';
import GroupAvatar from 'groups/components/GroupAvatar';
import Input from 'components/Input';
import Row from 'components/Row';
import Text from 'components/Text';

import './styles/GroupRequestApprovalModal.scss';

const GroupRequestApprovalModal = (props: any) => {
  const {
    classToRequest,
    classRequestButtonEnabled,
    orgName,
    onChange,
    onClickCancel,
    onRequestHide,
    onSubmit,
    selectedAvatarUrl,
  } = props;
  const classCode = classToRequest?.getCode();
  const className = classToRequest?.getName();

  return (
    <Dialog
      className="GroupRequestApprovalModal"
      title="Request approval"
      size="small"
      onRequestHide={onRequestHide}>
      <BoxBody>
        {/* Render class card */}
        <Row>
          <div className="GroupRequestApprovalModal-classCard">
            <AvatarWithText
              avatar={
                <GroupAvatar
                  group={{
                    groupAvatar: { svg_url: selectedAvatarUrl },
                  }}
                />
              }
              gutter="medium"
              subtext={`@${classCode}`}
              title={className}
            />
          </div>
        </Row>

        <Text element="p" color="thunder" align="left">
          {`To associate this class with ${orgName}, let school administrators know the purpose of this class.`}
        </Text>
        
        <FormElement
          label="Class purpose"
          validate={e => {
            const requestReasonText = e.target.value.trim();
            onChange(requestReasonText);
          }}
          element={Input}
          elementProps={{
            required: true,
            autofocus: true,
          }}
        />
        <Button full disabled={!classRequestButtonEnabled} onClick={onSubmit} data-test-selector="group-create-modal-submit-class-create-request">
          Request to create class
        </Button>
        <Button full color="white" onClick={onClickCancel}>
          Cancel
        </Button>
      </BoxBody>
    </Dialog>
  );
};

export default GroupRequestApprovalModal;
